import { render, staticRenderFns } from "./dhcpReserved.vue?vue&type=template&id=8c290ec0&scoped=true&"
import script from "./dhcpReserved.vue?vue&type=script&lang=js&"
export * from "./dhcpReserved.vue?vue&type=script&lang=js&"
import style0 from "./dhcpReserved.vue?vue&type=style&index=0&id=8c290ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c290ec0",
  null
  
)

export default component.exports